const EMAIL_VALIDATION_REGEX =
  /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)+$/;

export function validateEmail (email) {
  return email && email.match(EMAIL_VALIDATION_REGEX);
};



// WEBPACK FOOTER //
// ./src/components/call-center/utils/function_helper.js